export class Market {
  id: number;
  name: string;
  acronym: string;
  enabled: boolean;

  constructor(id: number, name: string, acronym: string, enabled: boolean) {
    this.id = id;
    this.name = name;
    this.acronym = acronym;
    this.enabled = enabled
  }
}
 